export default class RhColors
{
    //public static readonly BTN_PRIMARY:string = "#FF355E";
    public static readonly BTN_PRIMARY:string = "#9550B4";
    public static readonly BTN_SECONDARY:string = "#FFFFFF";
    public static readonly HIGHLIGHT_PRIMARY:string = "#00E2FF";
    public static readonly MARK_PRIMARY:string = "#363538";
    public static readonly PRIMARY:string = "#9550B4";
    public static readonly SECONDARY:string = "#FFFFFF";
    public static readonly WHITE:string = "#FFFFFF";
}